import { Model } from '@vuex-orm/core'
import { Outdoor, Town, Building, Dungeon } from './AreaHierarchy'
import Quest from './Quest'
import Boss from './Boss'
import Secret from './Secret'
import Tome from './Tome'

export class Area extends Model {
    static entity = 'areas'


    static types () {
        return {
          AREA: Area,
          OUTDOOR: Outdoor,
          TOWN: Town,
          BUILDING: Building,
          DUNGEON: Dungeon
        }
      }

    static fields() {
        return {
            id: this.attr(null),
            type: this.attr('AREA'),
            grid_id: this.attr(null),
            completed: this.attr(false),
            quests: this.hasMany(Quest, 'area_id'),
            bosses: this.hasMany(Boss, 'area_id'),
            secrets: this.hasMany(Secret, 'area_id'),
            tomes: this.hasMany(Tome, 'area_id')
        }
    }
}

// We also export a default.
export default Area;